module.exports = __webpack_public_path__ + "static/img/10.23b7a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.png
// module id = rhId
// module chunks = 1